import domReady from '@wordpress/dom-ready';
import { commandLoader } from './command-loader';

domReady( function () {
	commandLoader();
} );
